/**
 * damage_mode — which persistent-damage graph a material gets and whether the runtime draws any (shader gaps R2).
 * One place: the tier flag (`TierPreset.materialDamage`), the kill switch `localStorage 'atlas:damage' = 'off'`, and
 * the default for a saved profile that predates the flag. Kept apart from the runtime so the ground's shader
 * (`wetness.ts`) can ask without importing the game state.
 */
import { activePreset } from './quality_tiers.js';
import type { DamageMode } from './damage_layer.js';

/** A profile saved before the flag existed has none: the marks (albedo / roughness / metalness) — the cheap half. */
export const DAMAGE_MODE_DEFAULT: DamageMode = 'marks';

export function damageKillSwitch(): boolean {
  try { return typeof localStorage !== 'undefined' && localStorage.getItem('atlas:damage') === 'off'; } catch { return false; }
}

export function damageMode(): DamageMode {
  if (damageKillSwitch()) return 'off';
  const m = activePreset().materialDamage;
  return m === 'off' || m === 'marks' || m === 'full' ? m : DAMAGE_MODE_DEFAULT;
}
